/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import {useEffect, useState, useCallback} from 'react';
import {Accordion, Button} from 'react-bootstrap';
import CustomListGroupAction from 'components/Custom/ListGroup/CustomListGroupAction';
import CustomSelectionItemAction from './CustomSelectionItemAction';

import type {
	IActionForm,
	ConditionObject,
	Xml2Js,
	IPccRuleFormDynamic,
} from 'interfaces';
import {
	defaultFormDataAction,
	defaultRuleDynamicDataAction,
	defaultRuleStaticDataAction,
	defaultResetSMSDataAction,
	labelActions,
	transformLabelActions,
	resolveFieldKey,
	setNestedField,
	getNestedField,
} from './utils/InitActionLabels';
import {cleanActionFormForXML} from 'utils';
import {useAppSelector} from 'store/hooks';
import RuleActionForm from './RuleActionForm';

type TProps = {
	onChange: (arg: Xml2Js) => void;
	rowData: Xml2Js;
	onObserver: (isValid: boolean) => void; // validator submit btn
	typeForm: string;
};

const ActionForm = ({onChange, rowData, typeForm, onObserver}: TProps) => {
	const {state: stateSystem} = useAppSelector(
		state => state.systemConfigProperty,
	);
	const isVolTE = stateSystem === 'VolTE';

	const [actions, setActions] = useState<IActionForm>({
		...defaultFormDataAction(),
	} as never);

	// default values
	useEffect(() => {
		if (!rowData?.actions) return;
		const normalizeInput = (action: any): any => {
			const normalized: any = {};
			for (const key in action) {
				const value = action[key];

				if (
					typeof value === 'object' &&
					value !== null &&
					Object.keys(value).every(k => !isNaN(Number(k)))
				) {
					normalized[key] = Object.values(value);
				} else {
					normalized[key] = value;
				}
			}
			return normalized;
		};

		const raw = normalizeInput(rowData?.actions);

		const tmpFormData = defaultFormDataAction(raw);
		setActions(tmpFormData);
	}, [rowData]);

	/* The above code is a `useEffect` hook that is triggered whenever the `formData` variable changes. It
	creates a copy of the `formData` object, renames some of its properties, and deletes some other
	properties. Then it calls the `onChange` function with the modified object as an argument. The
	purpose of this code is to transform the `formData` object into a format that can be used by
	another part of the codebase. */
	useEffect(() => {
		const tmp = cleanActionFormForXML(JSON.parse(JSON.stringify(actions)));

		onChange({
			actions: tmp,
		} as never);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [actions]);

	const handleUpdateRuleDynamic = useCallback(
		(id: string, updatedRule: IPccRuleFormDynamic) => {
			setActions(prev => {
				const newPccRuleDynamic = prev.pccRuleDynamic.map(rule =>
					rule.id === id ? updatedRule : rule,
				);

				return {
					...prev,
					pccRuleDynamic: newPccRuleDynamic,
				};
			});
		},
		[],
	);

	const handleFieldSelect = (id: string, ...path: string[]) => {
		const resetToDefault = (prevActions: IActionForm, keys: string[]) => {
			const defaultData = defaultFormDataAction();
			const defaultValue = getNestedField(defaultData, keys);
			if (defaultValue === undefined) return prevActions;
			return setNestedField(prevActions, keys, defaultValue);
		};

		setActions(prevActions => {
			if (prevActions.id !== id) return prevActions;

			const fieldNameConvert = resolveFieldKey(...path);
			if (!fieldNameConvert) return prevActions;

			// Manejo generalizado para otras etiquetas complejas
			if (Array.isArray(fieldNameConvert)) {
				const [parentKey, ...nestedKeys] = fieldNameConvert;
				const currentField = getNestedField<ConditionObject<any>>(prevActions, [
					parentKey,
					...nestedKeys,
				]);

				if (!currentField) return prevActions;
				const isLeaf = currentField.active !== undefined;
				if (isLeaf) {
					// Comportamiento original para ConditionObject simple
					const updatedField = {
						...currentField,
						active: !currentField.active,
					};
					if (!updatedField.active) {
						return resetToDefault(prevActions, [parentKey, ...nestedKeys]);
					}
					return setNestedField(
						prevActions,
						[parentKey, ...nestedKeys],
						updatedField,
					);
				} else {
					const updatedField: Record<string, any> = {};
					let allInactive = true;

					for (const subKey of Object.keys(currentField)) {
						const child = (currentField as any)[subKey];
						if (child && typeof child === 'object' && 'active' in child) {
							const toggled = {...child, active: !child.active};
							updatedField[subKey] = toggled;
							if (toggled.active) allInactive = false;
						} else {
							updatedField[subKey] = child;
						}
					}

					if (allInactive) {
						return resetToDefault(prevActions, [parentKey, ...nestedKeys]);
					}

					return setNestedField(
						prevActions,
						[parentKey, ...nestedKeys],
						updatedField,
					);
				}
			}

			// Manejo para etiquetas simples
			if (fieldNameConvert in prevActions) {
				const currentField = prevActions[fieldNameConvert as keyof IActionForm];

				if (
					path &&
					(path[0] === 'Dynamic PCC Rule' ||
						path[0] === 'Static PCC Rule' ||
						path[0] === 'Reset SMS')
				) {
					const valueField = !currentField;
					if (!valueField) {
						if (path[0] === 'Dynamic PCC Rule') {
							return {
								...prevActions,
								pccRuleDynamic: [],
								[fieldNameConvert]: valueField,
							};
						} else if (path[0] === 'Static PCC Rule') {
							return {
								...prevActions,
								pccRuleStatic: [],
								[fieldNameConvert]: valueField,
							};
						} else {
							return {
								...prevActions,
								resetSMS: [],
								[fieldNameConvert]: valueField,
							};
						}
					} else {
						return {
							...prevActions,
							[fieldNameConvert]: valueField,
						};
					}
				} else if (
					typeof currentField === 'object' &&
					currentField &&
					'active' in currentField
				) {
					const updatedField = {
						...currentField,
						active: !currentField.active,
					};
					if (!updatedField.active) {
						const keysToReset = [fieldNameConvert];

						return keysToReset.reduce(
							(updated, key) => resetToDefault(updated, [key]),
							prevActions,
						);
					}
					return {
						...prevActions,
						[fieldNameConvert]: updatedField,
					};
				}
			}
			return prevActions;
		});
	};

	const updateFormData = (
		keyForm: string,
		path: string[],
		value: string,
		type: string,
		checked: boolean,
		key: number | string | null,
	) => {
		const valueField = type === 'checkbox' ? checked : value;
		const deepUpdate = (
			obj: any,
			tags: string[],
			valueArg: any,
			itemId?: string | number | null,
		): any => {
			if (tags.length === 0) return obj;

			const [current, ...rest] = tags;
			const next = obj?.[current];

			// Si es un array y tenemos una key por ID
			if (Array.isArray(next) && itemId !== null && rest.length > 0) {
				return {
					...obj,
					[current]: next.map((item: any) =>
						item.id === itemId ? deepUpdate(item, rest, valueArg, null) : item,
					),
				};
			}

			// Último nivel: actualizar .value dentro del objeto
			if (rest.length === 0) {
				if (typeof next === 'object' && next !== null) {
					return {
						...obj,
						[current]: {
							...next,
							value: valueArg,
						},
					};
				}
				return obj;
			}

			return {
				...obj,
				[current]: deepUpdate(next ?? {}, rest, valueArg, itemId),
			};
		};

		setActions(prevActions => {
			if (
				type === 'text' ||
				type === 'number' ||
				type === 'select-one' ||
				type === 'checkbox' ||
				type === 'textarea'
			) {
				return deepUpdate(prevActions, path, valueField, key);
			}
			return prevActions;
		});
	};

	const handleRuleDynamicAdd = () => {
		setActions(prev => ({
			...prev,
			pccRuleDynamic: [
				...(prev.pccRuleDynamic || []),
				defaultRuleDynamicDataAction(),
			],
		}));
	};

	const handleRuleStatic = () => {
		setActions(prev => ({
			...prev,
			pccRuleStatic: [
				...(prev.pccRuleStatic || []),
				defaultRuleStaticDataAction(),
			],
		}));
	};

	const handleResetSMS = () => {
		setActions(prev => ({
			...prev,
			resetSMS: [...(prev.resetSMS || []), defaultResetSMSDataAction()],
		}));
	};

	const handleRuleStaticRemove = (ruleId: string) => {
		setActions(prevRule => ({
			...prevRule,
			pccRuleStatic: prevRule.pccRuleStatic.filter(item => item.id !== ruleId),
		}));
	};

	const handleResetSMSIdRemove = (policyId: string) => {
		setActions(prevRule => ({
			...prevRule,
			resetSMS: prevRule.resetSMS.filter(item => item.id !== policyId),
		}));
	};

	const handleRuleDynamicDelete = () => {
		setActions(prevRule => ({
			...prevRule,
			pccRuleDynamic: [],
		}));
	};

	const handleRuleDynamicIdRemove = (ruleId: string) => {
		setActions(prevRule => ({
			...prevRule,
			pccRuleDynamic: prevRule.pccRuleDynamic.filter(
				item => item.id !== ruleId,
			),
		}));
	};

	return (
		<div className="container-fluid">
			{/* Intro */}
			<div className="rounded-3">
				<div className="row" style={{height: '70vh', overflow: 'hidden'}}>
					<div className="col-12 col-lg-6 col-xl-5" style={{height: '100%'}}>
						{/* list possible Actions */}
						<div className="row" style={{height: '100%'}}>
							<div className="col-12" style={{height: '100%'}}>
								<CustomListGroupAction
									options={transformLabelActions(
										labelActions,
										typeForm as 'App' | 'Gw',
										isVolTE,
									)}
									formData={actions}
									onSelect={handleFieldSelect}
									resolveKey={resolveFieldKey}
									nameDropdown={'Labels enabled'}
								/>
							</div>
						</div>
					</div>
					<div className="col-12 col-lg-6 col-xl-7" style={{height: '100%'}}>
						<div className="row" style={{height: '100%'}}>
							<div className="col-12" style={{height: '100%'}}>
								<CustomSelectionItemAction
									formData={actions}
									updateFormData={updateFormData}
									onObserver={onObserver}
									onAddRuleStatic={handleRuleStatic}
									onAddResetSMS={handleResetSMS}
									onDeleteRuleStatic={handleRuleStaticRemove}
									onDeleteResetSMSId={handleResetSMSIdRemove}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			{actions?.hasRuleDynamic && (
				<div className="rounded-3 text-bg-light mt-3 mb-4 px-4 pt-3 pb-3">
					<div className="row pt-2">
						<Accordion className="accordion-nested">
							<Accordion.Item
								eventKey={`pccDynamic`}
								key={`pccDynamic`}
								className="rounded border">
								<Accordion.Header className="position-relative">
									{`Dynamic PCC Rule`}
									<Button
										onClick={() => handleRuleDynamicDelete()}
										type="button"
										variant="secondary"
										className="border-0 bg-transparent btn-sm ml-2 d-inline position-absolute z-index top-0 end-0 pr-2 pt-3">
										<span className="btn-label">
											<i className="bi-1 bi-trash3-fill invalid-color" />
										</span>
									</Button>
								</Accordion.Header>
								<Accordion.Body>
									<div className="col m-3">
										<Button
											type="button"
											variant="secondary"
											className="btn btn-labeled btn-sm z-index mr-1"
											onClick={() => handleRuleDynamicAdd()}>
											<span className="btn-label mr-2">
												<i className="bi-1 bi-plus" />
											</span>
											Add Rule
										</Button>
									</div>
									{Array.isArray(actions?.pccRuleDynamic) &&
										actions?.pccRuleDynamic?.length > 0 &&
										actions?.pccRuleDynamic?.map((rule, index) => (
											<RuleActionForm
												key={'RuleActionForm'}
												rowRule={rule}
												headerAccordion={`Rule #${index + 1}`}
												typeForm={typeForm}
												isVolTE={isVolTE}
												onObserver={onObserver}
												onDeleteRuleDynamicId={handleRuleDynamicIdRemove}
												onUpdateRule={handleUpdateRuleDynamic}
											/>
										))}
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					</div>
				</div>
			)}
		</div>
	);
};

export default ActionForm;
